import React from "react";
import "./DeliveryInfo.css";
import { Truck, Clock, Phone } from "lucide-react";
import { motion } from "framer-motion";

const DeliveryInfo = () => {
  const locations =
    "Cardiff, Bridgend , Newport, Barry, Porth, Pontypridd, pinarth, Rhondda, Tonypandy, Pontyclun, Aberdare, Mountain Ash, Treorchy, Treherbert And Tonyrefail";

  return (
    <section className="delivery-info-section py-5">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="delivery-info-card"
        >
          <div className="row g-0">
            <div className="col-lg-8 p-4 p-md-5 delivery-main-content">
              <div className="d-flex align-items-center mb-4">
                <div className="icon-badge me-3">
                  <Truck size={24} />
                </div>
                <h3 className="h4 fw-bold mb-0">Alcohol Delivery Service 🔞</h3>
              </div>

              <div className="info-grid mb-4">
                <div className="info-item d-flex align-items-center mb-2">
                  <Clock size={16} className="text-danger me-2" />
                  <span>7 Days A Week | 24 Hours Availability</span>
                </div>
                <div className="info-item d-flex align-items-center">
                  <Phone size={16} className="text-danger me-2" />
                  <span>Call Now: <strong>07466 125973</strong> / <strong>029 2188 0665</strong></span>
                </div>
              </div>

              <div className="locations-box mt-4">
                <span className="badge bg-danger mb-2 text-uppercase">We Deliver To</span>
                <p className="locations-text mb-0">{locations}</p>
              </div>
            </div>

            <div className="col-lg-4 d-none d-lg-flex align-items-center justify-content-center bg-light p-4">
              <div className="text-center">
                <div className="display-4 fw-bold text-danger mb-0">24/7</div>
                <p className="text-muted text-uppercase small ls-2 font-weight-bold">Express Delivery</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DeliveryInfo;
